import { IconCopy } from '@posthog/icons';
import * as React from 'react';
export default {
  IconCopy,
  React
};